import User from '../models/User'

const isOperator = (user: User) => user && user.roles.some(r => r.name === 'operator')

export default isOperator
